module.exports = __webpack_public_path__ + "img/m-icon5.1fb17f6f.png";